// extracted by mini-css-extract-plugin
export var form = "recipe-notes-module--form--fTybP";
export var input = "recipe-notes-module--input--2hn4K";
export var note = "recipe-notes-module--note--8OH8F";
export var submitButton = "recipe-notes-module--submit-button--WM4FQ";